import React from "react";
import Draggable from "react-draggable";
import { GwDraggableProps } from "./dto";

/**
 * 可拖拽组件
 */
const GwDraggable = (props: GwDraggableProps) => {
  const { children, ...restPrpos } = props;

  return <Draggable {...restPrpos}>{children}</Draggable>;
};

export default GwDraggable;
